export const ResultsStates = {
	NO_RESULTS: 'noResults',
	INITIAL: 'initial',
	RESULTS: 'results',
	ERROR: 'error',
	IS_LOADING: 'isLoading',
} as const;
export type ResultsStates = (typeof ResultsStates)[keyof typeof ResultsStates];
